module.exports = __webpack_public_path__ + "img/icon-chef-hat.d06812ff.svg";